import React from 'react';
import { PageSubTitle } from 'Components/Titles';
import { SecondaryText } from 'Components/Texts';
import { RestartPlanChurned } from 'Features/MyAccount/RestartPlanChurned';

/**
 * this component will take care the MVPD, iOS and Android direct purchase message
 * @param {*} param
 */
export const AppPurchaseSubscription = ({
  subTitle,
  purchaseType,
  subscription: { isChurnedRestartAvailable = false, restartChurnedUserDetails = {} },
  onRestartPlan,
  getPlansSuccess,
  trackEditAccount,
}) => {
  const PURCHASE_TYPE_MESSAGES = {
    ios: 'You can manage your Fox Nation Subscription on your tvOS device by going to Settings -> [Your Name] -> iTunes & App Store -> Subscriptions.',
    android:
      'You can manage your Fox Nation Subscription on your Android device by going into Google Play -> Menu -> Subscriptions.',
    bango: 'To manage your subscription, please visit Verizon.',
    samsung: 'To manage your subscription, please visit your Samsung store.',
  };
  const configMessage = PURCHASE_TYPE_MESSAGES[purchaseType];

  if (configMessage || isChurnedRestartAvailable)
    return (
      <div className="sectionFlex membershipSection" data-testid="appPurchaseSubscription">
        <div className="flexGrowOne settingsSectionLeft">
          <PageSubTitle text={subTitle} />
        </div>
        <div className="sectionFlex flexDirCol flexGrowTwo settingsSectionRight">
          {purchaseType === 'bango' && <p className="bangoTitle sectionFlex secondaryText">+Play</p>}
          <div className="sectionFlex flexDirCol">
            {configMessage && <SecondaryText className="noMargin" text={configMessage} />}
            {isChurnedRestartAvailable && getPlansSuccess && (
              <div className={`sectionFlex ${!configMessage ? 'noMessage' : ''}`}>
                <RestartPlanChurned {...restartChurnedUserDetails} />
                <span
                  role="button"
                  className="blueLink block text-right cursorPointer restartChurnedPlan"
                  onClick={() => {
                    onRestartPlan();
                    trackEditAccount('Restart Plan');
                  }}
                >
                  Restart Plan
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  return null;
};
